<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content class="dialog-content">{{ message }}</div>
<div mat-dialog-actions align="end">
  @if (cancelButton) {
    <button mat-button mat-dialog-close (click)="cancel()">{{ cancelButton }}</button>
  }
  <button mat-button mat-dialog-close (click)="close()">{{ button }}</button>
</div>
